// Eager slim slice of the meet component barrel (bundle-fold, 2026-08-01).
//
// The full `./index.js` barrel `export *`s all 16 meet component files — the
// whole call/room/transcript/suggestion UI tree. sharedLibraries.js used to
// drag ALL of it into the shell's EAGER chunk by folding the full meet
// context (`import meet from '@symbo-ls/workspace-meet'`).
//
// Meet is now a lazy sub-app: the `/meet` + `/meet-guest` routes fold the
// FULL meet context into the live shell context on first mount
// (workspace/pages/index.js + pages/main.js → lazySharedLibPage/lazyPage).
// So every meet UI key those routes reference resolves against the folded
// context — none of the heavy page-body components (MeetMain, MeetSidebar,
// MeetRoomList, MeetVideoRoom, MeetParticipantTile, MeetControlBar,
// MeetTranscriptPage/Panel, MeetSuggestionCard, …) needs to be eager.
//
// Three component files stay eager, because non-meet surfaces mount/extend
// their keys BEFORE the /meet route folds the context, and none of those
// surfaces fold meet on their own:
//   • CallWidget.js — `MeetCallWidget` is bare-keyed at the shell root
//     (workspace/app.js), the persistent floating call dock that must stay
//     mounted (and visible) across every route while a call is live.
//   • ControlBarIconButton.js — `MeetCallWidget`'s own mic/return/leave
//     controls `extends: 'MeetControlBarIconButton'`; split out of
//     ControlBar.js (20KB, itself lazy) specifically so this shared base
//     stays tiny and self-contained.
//   • MeetNewRoomModal.js — `MeetNewRoomModal` is opened via a @symbo.ls/windows
//     custom-template layer (`content: { extends: 'MeetNewRoomModal' }`) by
//     `openNewRoomModal` (functions/eagerSlice.js), which the GLOBAL app
//     header's "New meeting" action (shared/components/AppHeader.js +
//     MainNavbar.js) and PersonPopover call from ANY route, long before
//     /meet ever mounts.
export * from './CallAudio.js'
export * from './CallWidget.js'
//   • MeetFlyConfirm.js — `MeetFlyConfirm` is bare-keyed at the shell root
//     beside MeetCallWidget: the confirm card of a spoken Fly ask in a call
//     (functions/meetFly.js meetFlyConfirm) must show on every route. Its
//     only import is meetFlyState.js, which the dock already pulls in.
export * from './MeetFlyConfirm.js'
export * from './ControlBarIconButton.js'
export * from './MeetNewRoomModal.js'
